<template>
  <material-card>
    <v-layout px-3 slot="header">
      <v-flex my-4 pl-4 title align-center justify-center>Użycie usług</v-flex>

      <v-spacer></v-spacer>
    </v-layout>

    <material-table
      :headers="table.headers"
      :items="list"
      :actions="false"
      :hideActions="false"
      :total-count="count"
      @pagination="reloadList"
    ></material-table>
  </material-card>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import {
  DisplayBenefitType,
  DisplayBenefitIconTypeTranslation,
  DisplayBenefitTypeTranslation
} from '@witkac/kartamiejska-shared';

import MaterialTable from '@/components/material/Table';
import { listMixin } from '@/mixins/list';
import MaterialCard from '@/components/material/Card';
import { DEFAULT_LIST_COUNT } from '@/utils/constants';

// @vuese
// Wyświetlanie zakładki historii usług klienta
// @group Client-Profile
export default {
  props: {
    // Czy pobierac historie partnera
    getPartner: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [
    listMixin(
      'benefitsHistory',
      {
        listError: 'Wystąpił błąd podczas pobierania historii.'
      },
      {},
      (to, from, next) => {
        next();
      }
    )
  ],
  data() {
    return {
      table: {
        headers: [
          { value: 'created', text: 'Data', sortable: true },
          { value: 'placeName', text: 'Obiekt', sortable: false },
          { value: 'name', text: 'Usługa', sortable: false },
          { value: 'type', text: 'Rodzaj zniżki', sortable: false },
          { value: 'price', text: 'Cena bazowa (PLN)', sortable: true },
          { value: 'benefitValue', text: 'Wartość', sortable: false }
        ]
      }
    };
  },
  components: { MaterialCard, MaterialTable },
  computed: {
    ...mapState({
      list: state =>
        state.benefitsHistory.list.map(benefitUse => {
          benefitUse.placeName = benefitUse.place.name;
          benefitUse.created = moment(benefitUse.created).format('YYYY-MM-DD HH:mm');
          benefitUse.name = benefitUse.benefit.name;
          benefitUse.type = `${DisplayBenefitTypeTranslation[benefitUse.benefit.type]}${
            benefitUse.benefit.type === DisplayBenefitType.PERCENT_DISCOUNT ? ` (${benefitUse.benefit.value}%)` : ''
          }`;

          switch (benefitUse.benefit.type) {
            case DisplayBenefitType.AMOUNT_DISCOUNT:
              benefitUse.benefitValue = `${benefitUse.benefit.value} zł`;
              break;
            case DisplayBenefitType.TIME:
              benefitUse.benefitValue = benefitUse.value + ' min';
              break;
            case DisplayBenefitType.PERCENT_DISCOUNT:
              benefitUse.benefitValue = `${(benefitUse.price * (benefitUse.benefit.value / 100)).toFixed(2)} zł`;
              break;
            default:
              benefitUse.benefitValue = benefitUse.value;
              break;
          }
          return benefitUse;
        })
    })
  },
  methods: {
    /**
     * Tworzy filtry na podstawie paginacji
     *
     * @param {*} pagination
     * @returns
     */
    filters(pagination) {
      return this.getPartner
        ? { ...pagination, partnerId: this.$store.state.partners.id }
        : { ...pagination, profileId: this.$store.state.client.data.profile.id };
    }
  }
};
</script>
